import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/settings/segments/:id
//
// Caller is responsible for navigation — server returns { ok: true } and
// the SPA's segment-detail page navigates back to the list view.
export function useDeleteSegment() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, string>({
    mutationFn: (id) =>
      apiFetch<{ ok: true }>(`/settings/segments/${id}`, { method: "DELETE" }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.segments() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete segment");
    },
  });
}
